import store from '@/store';
const siteValue = store.state.siteValue;
const siteList = store.state.siteList;

export function isEn() {
  let keywords = '';
  let isEn = '';
  siteList.map((s) => {
    if (s.id == siteValue) {
      keywords = s.keywords;
    }
  });
  return keywords.includes('en') ? true : false;
}
